import { z } from "zod";
import { nanoid } from "@scalar-org/entities/utility";
const attributesTabSchema = z.object({
  id: z.string().default(() => nanoid()),
  title: z.string()
});
const attributesTabsSchema = z.object({
  children: z.array(attributesTabSchema),
  default: z.string().optional(),
  isMdx: z.boolean().optional()
});
export {
  attributesTabSchema,
  attributesTabsSchema
};
//# sourceMappingURL=attributes.js.map
